import { AvailabilityDto } from './availability-dto';

export interface WeekAvailabilityDto {
  available: AvailabilityDto[];
  in_store_zone: boolean;
  in_vehicle_zone: boolean;
  week?: number;
  year?: number;
  uber: boolean;
}
